import { useState } from "react";
import { GOSPEL_SIX_TRUTHS } from "@/lib/nav";
import { T } from "@/constants/testIds";

export default function GospelSixTruths() {
  const [active, setActive] = useState(1);
  const current = GOSPEL_SIX_TRUTHS.find((t) => t.n === active);

  return (
    <section data-testid={T.gospelSixTruths} className="bg-ink text-background py-20 sm:py-28 relative overflow-hidden">
      {/* Ghost number of the active truth */}
      <span
        aria-hidden
        className="absolute -left-6 bottom-0 font-serif text-[300px] leading-none text-background/[0.04] pointer-events-none select-none hidden lg:block"
      >
        0{active}
      </span>
      <div className="container-editorial grid grid-cols-1 md:grid-cols-12 gap-10 relative">
        <div className="md:col-span-5">
          <span className="eyebrow text-gold flex items-center gap-2">
            <span className="h-px w-6 bg-gold/70" />
            The Gospel in Six Truths
          </span>
          <h2 className="heading-2 mt-4 text-background">
            The <em className="italic text-gold">good news</em>, in one clear picture.
          </h2>
          <p className="text-background/70 mt-6 leading-relaxed">
            The Gospel is not a self-improvement plan. It is the announcement of what God has done for us in Christ.
            Read these six truths in order — each builds on the last.
          </p>
        </div>

        <div className="md:col-span-7">
          <div className="border border-background/15">
            {GOSPEL_SIX_TRUTHS.map((t) => (
              <button
                key={t.n}
                data-testid={T.gospelTruth(t.n)}
                onClick={() => setActive(t.n)}
                aria-expanded={active === t.n}
                className={`w-full text-left px-6 sm:px-8 py-5 flex items-start gap-6 border-b border-background/10 last:border-0 transition-colors ${
                  active === t.n ? "bg-background/5" : "hover:bg-background/5"
                }`}
              >
                <span
                  className={`font-serif text-3xl w-10 shrink-0 ${
                    active === t.n ? "text-gold" : "text-background/40"
                  }`}
                >
                  0{t.n}
                </span>
                <div className="flex-1">
                  <div className="flex items-center justify-between gap-4">
                    <h3 className="font-serif text-xl sm:text-2xl text-background" style={{ fontWeight: 500 }}>
                      {t.title}
                    </h3>
                    <span className="text-[10px] uppercase tracking-widest text-background/50">{t.scripture}</span>
                  </div>
                  {active === t.n && (
                    <p className="mt-3 text-background/80 leading-relaxed animate-fade-up">{t.body}</p>
                  )}
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
